import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { USER_QUERIES, UserQueries } from '@/app/platform/platform-core/user/store/types';

@Injectable({
  providedIn: 'root'
})
export class BlockIfNotAuthenticatedGuard  {
  constructor(
    @Inject(USER_QUERIES)
    private readonly userQueries: UserQueries,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActiveSelfOrChild();
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActiveSelfOrChild();
  }

  private canActiveSelfOrChild(): boolean {
    if (this.doRedirect) {
      this.router.navigate(['/login']);
    }

    return this.userQueries.getIsAnyUserAuthenticated();
  }

  private get doRedirect(): boolean {
    return !this.userQueries.getIsAnyUserAuthenticated();
  }
}
